import styles from "./FilePreview.module.css";

interface FilePreviewProps {
	file: File;
	dataUrl: string;
	onRemove: () => void;
}

function CrossIcon({ size = 10 }: { size?: number }) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>Remove</title>
			<path
				d="M18 6L6 18M6 6l12 12"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function FileIcon({ size = 20 }: { size?: number }) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>File</title>
			<path
				d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14 2v6h6M16 13H8M16 17H8M10 9H8"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

function PdfIcon({ size = 24 }: { size?: number }) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<title>PDF file</title>
			<path
				d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
				fill="#FEE2E2"
				stroke="#B91C1C"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path d="M14 2l6 6h-4a2 2 0 01-2-2V2z" fill="#FCA5A5" />
			<path
				d="M8 13h2.5c.97 0 1.75-.78 1.75-1.75S11.47 9.5 10.5 9.5H8v6.5"
				fill="none"
				stroke="#B91C1C"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13 16V9.5h1.5a2.25 2.25 0 110 4.5H13"
				fill="none"
				stroke="#B91C1C"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M18 9.5h-1.75V16"
				fill="none"
				stroke="#B91C1C"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}

export function FilePreview({ file, dataUrl, onRemove }: FilePreviewProps) {
	const isImage = file.type.startsWith("image/");
	const isPdf = file.type === "application/pdf";

	const getFileLabel = () => {
		if (isPdf) return "PDF";
		if (file.type.includes("text")) return "TXT";
		return "FILE";
	};

	return (
		<div className={styles.container}>
			<div className={styles.previewWrapper}>
				<div className={styles.preview}>
					{isImage ? (
						<img src={dataUrl} alt={file.name} className={styles.image} />
					) : (
						<div
							className={`${styles.fileIcon} ${isPdf ? styles.pdfIcon : ""}`}
						>
							{isPdf ? <PdfIcon size={24} /> : <FileIcon size={20} />}
							<span
								className={`${styles.fileLabel} ${isPdf ? styles.pdfLabel : ""}`}
							>
								{getFileLabel()}
							</span>
						</div>
					)}
				</div>

				<button
					type="button"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						onRemove();
					}}
					className={styles.removeButton}
					aria-label="Remove attachment"
				>
					<CrossIcon size={10} />
				</button>
			</div>
			<div className={styles.fileName}>{file.name}</div>
		</div>
	);
}
